import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const EMailIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M19.997 6.494C19.9929 6.3881 19.9547 6.28637 19.888 6.204L19.872 6.182C19.869 6.177 19.864 6.174 19.86 6.169C19.8467 6.15495 19.8327 6.1416 19.818 6.129C19.806 6.119 19.795 6.109 19.782 6.1C19.768 6.09 19.752 6.081 19.737 6.072L19.694 6.049L19.646 6.03L19.599 6.016C19.5652 6.00826 19.5307 6.00357 19.496 6.002L19.476 6H4.524L4.506 6.002C4.4873 6.00363 4.46863 6.00563 4.45 6.008L4.403 6.016C4.386 6.02 4.37 6.026 4.353 6.032C4.338 6.037 4.322 6.042 4.307 6.049C4.27616 6.06365 4.24671 6.08106 4.219 6.101C4.19116 6.1222 4.16508 6.14561 4.141 6.171L4.128 6.182C4.122 6.189 4.118 6.197 4.113 6.204C4.08064 6.24611 4.05439 6.29256 4.035 6.342C4.01668 6.3907 4.00621 6.44201 4.004 6.494L4 6.524V16.658C4 16.946 4.234 17.18 4.523 17.18H19.477C19.6155 17.18 19.7484 17.125 19.8465 17.0272C19.9445 16.9293 19.9997 16.7965 20 16.658V6.524L19.997 6.494ZM12 11.144L6.54 7.294H17.46L12 11.144ZM5.296 15.721V8.08L11.7 12.58C11.7443 12.6163 11.7939 12.6457 11.847 12.667C11.925 12.692 11.977 12.703 12.03 12.703C12.1466 12.7003 12.2591 12.6592 12.35 12.586C12.351 12.584 14.49 11.081 18.764 8.078V15.72H5.296V15.721Z'
                fill='currentColor'
            />
        </>
    ),
})

EMailIcon.displayName = 'EMailIcon'
